import { observer } from 'mobx-react';
import ModalStore from '../../../../../../../../Modal/Store';
import { LearningCollectionResource } from '../../../../../../../Types';
import InviteParticipantStore from '../../../../Store';
import { SelectParticipantsState } from '../../../../Types';
import LicenseExpiredModal from './LicenseExpiredModal';
import ReadyModal from '..';
import { just } from 'maybeasy';
import { whenLte } from '@execonline-inc/numbers';

export interface Props {
  modalStore: ModalStore;
  store: InviteParticipantStore;
  learningCollectionResource: LearningCollectionResource;
  state: SelectParticipantsState;
}

function ModalContent({ store, modalStore, learningCollectionResource, state }: Props) {
  return just(state.daysUntilRenewal)
    .andThen(whenLte(0))
    .map(() => <LicenseExpiredModal close={modalStore.close} title={state.publicName} />)
    .getOrElse(() => (
      <ReadyModal
        modalStore={modalStore}
        state={state}
        learningCollectionResource={learningCollectionResource}
        store={store}
      />
    ));
}

export default observer(ModalContent);
